import { detectisChrome, detectisEdge } from 'yoda-core-components/lib/helpers/Utils/Utils';
import { onCLS, onFCP, onLCP, onTTFB } from 'web-vitals/attribution';
import { constructWebVitalMetric, getNumbersWithInterval } from '../helpers/Utils/utils';

const debounce = (fn, interval = 3000) => {
    let timer;
    /* istanbul ignore next */
    return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => {
            fn(...args);
        }, interval);
    };
};

const intervals = {
    CLS: getNumbersWithInterval(0.02, 0.3),
    FCP: getNumbersWithInterval(0.25, 4),
    LCP: getNumbersWithInterval(0.25, 8),
    TTFB: getNumbersWithInterval(0.1, 1.9),
};

const reportWebVitals = (onPerfEntry, enableWebvitalsReportAllChanges) => {
    if (onPerfEntry && onPerfEntry instanceof Function) {
        onFCP(onPerfEntry, { reportAllChanges: enableWebvitalsReportAllChanges });
        onTTFB(onPerfEntry, { reportAllChanges: enableWebvitalsReportAllChanges });
        onLCP(onPerfEntry, { reportAllChanges: enableWebvitalsReportAllChanges });
        onCLS(onPerfEntry, { reportAllChanges: enableWebvitalsReportAllChanges });
        // INp will be phase2
        // onINP(onPerfEntry, { reportAllChanges: enableWebvitalsReportAllChanges });
    }
};

export const logwebvitals = (store, digitalData = {}, callAnalyticsTrack = () => {}) => {
    try {
        const stateObj = store.getState();
        const disableTrackWebVitals = stateObj?.context?.featureFlags?.disableTrackWebVitals;
        const enableKibanaLog = stateObj?.context?.featureFlags?.enableKibanaLog || true;
        const webvitalTimer = stateObj?.context?.preferences?.webvitalTimer || 300;
        const enableWebvitalsReportAllChanges =
            stateObj?.context?.featureFlags?.enableWebvitalsReportAllChanges || true;
        const isWebvitalsTriggered = stateObj?.webvitals?.isWebvitalsTriggered;
        let isAnalyticsTriggered = false;
        let isAllVitalsCaptured = false;

        /* istanbul ignore next */
        if (!disableTrackWebVitals && !isWebvitalsTriggered) {
            store.dispatch({
                type: 'TRIGGER_WEBVITALS',
            });
            const isEdgeOrChrome = detectisEdge() || detectisChrome();
            const minWebvitalToWait = isEdgeOrChrome ? 4 : 2; // safari, firefox supports TTFB and FCP only
            const data = {};
            const startTime = new Date().getTime();

            const storeWebvitalInfoInWindow = () => {
                if (Object.keys(data).length === minWebvitalToWait && !isAllVitalsCaptured) {
                    window.webvitalsAnalytics = { ...data };
                    isAllVitalsCaptured = true;
                }
            };
            const storeWebVitalsInfoInDigitalData = (fromMethod) => {
                if (!isAnalyticsTriggered) {
                    try {
                        digitalData.webvitalMetric = { ...data };
                        console.log(fromMethod);
                        if (enableKibanaLog) {
                            store.dispatch({
                                type: 'LOG_CLIENT_ERROR',
                                payload: {
                                    errorType: `webvitals Data ${fromMethod}`,
                                    errorDescription: digitalData.webvitalMetric
                                        ? `${JSON.stringify(
                                              digitalData.webvitalMetric
                                          )} | ${fromMethod}-startTime ${
                                              new Date().getTime() - startTime
                                          }`
                                        : '',
                                },
                            });
                        }
                        callAnalyticsTrack();
                        isAnalyticsTriggered = true;
                    } catch (e) {
                        console.log('error in webvitals function', e);
                        callAnalyticsTrack();
                    }
                }
            };

            reportWebVitals((eachMetric) => {
                const metric = constructWebVitalMetric(eachMetric, intervals);
                data[metric?.name] = metric;
                if (Object.keys(data).length === minWebvitalToWait) {
                    storeWebVitalsInfoInDigitalData('all4');
                    storeWebvitalInfoInWindow();
                }
            }, enableWebvitalsReportAllChanges);

            debounce(() => {
                storeWebVitalsInfoInDigitalData('debounce');
            }, webvitalTimer)();
        }
    } catch (e) {
        console.log('error in webvitals function', e);
        callAnalyticsTrack();
    }
};

export default logwebvitals;
